import { Grid } from '@material-ui/core';

const Home = () => <Grid>Fleetly</Grid>;

export default Home;
